//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscPin(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.5 10C15.5 8.07 13.93 6.5 12 6.5C10.07 6.5 8.5 8.07 8.5 10C8.5 11.93 10.07 13.5 12 13.5C13.93 13.5 15.5 11.93 15.5 10ZM10.5 10C10.5 9.17 11.17 8.5 12 8.5C12.83 8.5 13.5 9.17 13.5 10C13.5 10.83 12.83 11.5 12 11.5C11.17 11.5 10.5 10.83 10.5 10Z" fill="currentColor" /><path d="M12 2C7.59 2 4 5.59 4 10C4 13.58 6.12 16.38 9.01 19.15L10.52 17.82C7.52 14.97 6 12.74 6 10C6 6.69 8.69 4 12 4C15.31 4 18 6.69 18 10C18 13.17 15.98 15.64 12 19.17L10.49 20.51C10.77 20.76 12 21.83 12 21.83C16.8 17.65 20 14.53 20 10C20 5.59 16.41 2 12 2Z" fill="currentColor" /></svg>;
}
export default IconMiscPin;